import { enumSchema } from "vue-utils"

export enum MarriageGender {
	Male = "Male",
	Female = "Female",
}

export const MarriageGenderSchema = enumSchema(MarriageGender)
